import React, { useState } from "react";
import { CreateSupport } from "../../pages";
import { SupportController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import * as yup from "yup";
import { userStore } from "../../stores";

const CreateSupportContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      name: yup.string().required("Enter business Name"),
      title: yup.string().required("Enter ticket title"),
      message: yup.string().required("Enter ticket description"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      ...values,
      ...(values.files.length > 0 && { file: values.files[0] }),
      business: values?.user,
    };

    delete payload.files;
    delete payload.name;
    delete payload.user;

    const { status, errorMessage } =
      await SupportController.createSupport(payload);
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    } else {
      MimaToastUtil.error({
        message: errorMessage,
      });
    }
    return setLoading(false);
  };

  const onModalClose = () => {
    closeModal();
    userStore.setSelectedId("");
  };

  return (
    <CreateSupport
      closeModal={onModalClose}
      onSubmit={onSubmit}
      loading={loading}
      validationSchema={validationSchema}
    />
  );
};
export default CreateSupportContainer;
